import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import { NavLink } from 'react-router-dom';

import * as Colors from '../../../../attrs/colors';
import MQ from '../../../../attrs/mq';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 1rem;
  margin: 3rem 0 0 0;

  ${MQ.lg`
    padding: 0 2rem;
  `}
`;

export const Menu = styled.ul`
  list-style: none;
  margin: 0 0 2rem;
  padding: 0;
`;

export const MenuItem = styled.li`
  font-size: 1rem;

  ${(props) =>
    props.buttons &&
    css`
      text-align: center;
      padding: 1rem 0 0 0;
    `}
`;

const link = `
  display: block;
  text-decoration: none;
  color: ${rgba(Colors.WHITE, 0.6)};
  padding: .5rem 0px;
  font-weight: bold;
  transition: color .2s ease-in-out;

  &:hover,
  &.active {
    color: ${Colors.WHITE};
  }
`;

export const MenuLink = styled.a`
  ${link};
`;

export const MenuNavLink = styled(NavLink)`
  ${link};
`;

export const Sup = styled.span`
  font-size: 0.7rem;
  vertical-align: super;
  padding-left: 0.25rem;
`;
